// extracted by mini-css-extract-plugin
module.exports = {"Title":"styles_Title__BjJsQ","Heading":"styles_Heading__ghhcR","Link":"styles_Link__24kYA","List":"styles_List__1ulSC"};